import { MoreVert } from "@mui/icons-material";
import { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import EditAdsModal from "./editAdsModal";
import {
	useToggleSuspendAdMutation,
	useDeleteAdMutation,
} from "src/store/services/adminApi";

const AdsTableActionBtn = ({
	callback,
	ad,
}: {
	callback: () => void;
	ad: IAdvertisement;
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const navigate = useNavigate();

	// RTK Query mutations
	const [toggleSuspendAd, { isLoading: isSupending }] =
		useToggleSuspendAdMutation();
	const [deleteAd, { isLoading: isDeleting }] = useDeleteAdMutation();

	const suspendAds = async () => {
		try {
			const result = await toggleSuspendAd(ad._id).unwrap();
			toast.success(result?.message || "Successful");
			callback();
		} catch (error: any) {
			const errorMessage =
				error?.data?.error?.message || error?.message || "Something went wrong";
			toast.error(errorMessage);
		}
	};

	const handleDeleteAd = async () => {
		try {
			const result = await deleteAd(ad._id).unwrap();
			toast.success(result?.message || "Successful");
			callback();
		} catch (error: any) {
			const errorMessage =
				error?.data?.error?.message || error?.message || "Something went wrong";
			toast.error(errorMessage);
		}
	};

	const handleViewInsights = () => {
		setIsOpen(false);
		navigate(`/ads/insights/${ad._id}/${ad.adminId}`, {
			state: {
				adData: ad,
			},
		});
	};

	return (
		<div className='relative'>
			<i
				onClick={() => setIsOpen(!isOpen)}
				className='cursor-pointer text-gray-600 hover:text-gray-800' // Added cursor and hover color for better UX
			>
				<MoreVert />
			</i>
			{isOpen && (
				<div className='flex flex-col items-start bg-white rounded-md p-4 absolute right-0 z-10 shadow-md border border-gray-200'>
					<button
						onClick={() => {
							setIsModalOpen(true);
						}}
						className='hover:bg-gray-100 p-3 rounded-md px-6 w-full text-left text-gray-700'
					>
						Edit
					</button>
					<button
						onClick={handleViewInsights}
						className='hover:bg-gray-100 p-3 rounded-md px-6 w-full text-left text-gray-700'
					>
						View Insights
					</button>
					<button
						onClick={suspendAds}
						className='hover:bg-gray-100 p-3 rounded-md px-6 w-full text-left text-gray-700'
					>
						{isSupending
							? "Loading..."
							: ad.status === "suspended"
							? "	Unsuspend"
							: "Suspend"}
					</button>

					<button
						onClick={handleDeleteAd}
						className='hover:bg-red-100 p-2 rounded-md px-6 w-full text-left text-red-600'
					>
						{isDeleting ? "Deleting..." : "Delete"}
					</button>
				</div>
			)}
			<EditAdsModal
				adData={ad}
				isOpen={isModalOpen}
				callback={callback}
				onClose={() => setIsModalOpen(false)}
			/>
		</div>
	);
};

export default AdsTableActionBtn;
